import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

// GET
export async function getTransitionsPortfolioData() {
  const response = await axios.get('/Portfolios');
  return response;
}

export async function getPortfolioData(id, facilityId) {
  const response = await axios.get(`/PortfolioData?id=${id}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function getPermissions(portfolioId) {
  const response = await axios.get(`/Permissions?portfolioId=${portfolioId}`);
  return response;
}

export async function getTransitionDefaultPortfolio() {
  const response = await axios.get(`/DefaultPortfolio`);
  return response;
}

export async function getTransitionDefaultFacility() {
  const response = await axios.get(`/DefaultFacility`);
  return response;
}

export async function getTransitionsStaffTypes() {
  const response = await axios.get('/StaffTypes');
  return response;
}

export async function getTransitionsStaffSubTypes() {
  const response = await axios.get('/StaffSubTypes');
  return response;
}

export async function getFiftyStatesList() {
  const response = await axios.get('/FiftyStatesList');
  return response;
}

export async function getFacilityStructuresList() {
  const response = await axios.get('/FacilityStructures');
  return response;
}

export async function getCompanyOptions() {
  const response = await axios.get('/CompanyOptions');
  return response;
}

// POST
export async function saveInitialDueDiligenceForm(data) {
  const formData = objectToFormData(data);
  const response = await axios.post('/SaveInitialDueDiligenceForm', formData);
  return response;
}

export async function getDueDiligenceData(id, facilityId) {
  const response = await axios.get(`/DueDiligenceData?id=${id}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function saveDueDiligenceForm(data) {
  const formData = objectToFormData({ dueDiligenceInputData: data });

  const response = await axios.post('/SaveDueDiligenceForm', formData);
  return response;
}

export async function updateStatus(id, statusId) {
  const response = await axios.post(`/UpdatePortfolioStatus?id=${id}&statusId=${statusId}`);
  return response;
}

export async function updateCanceledStatus(id, isCanceled) {
  const response = await axios.post(`/UpdatePortfolioCanceledStatus?portfolioId=${id}&isCanceled=${isCanceled}`);
  return response;
}

// GET
export async function openFile(id) {
  const response = await axios.get(`/OpenFile?fileId=${id}`, {
    responseType: 'blob',
  });
  return response;
}

//Post
export async function saveFile(file) {
  const formData = objectToFormData(file, null, 'file');
  formData.append(`file.physicalFile`, file.physicalFile);

  const response = await axios.post('/SaveFile', formData);
  return response;
}

export async function deleteFile(fileId) {
  const response = await axios.post(`/DeleteFile?fileId=${fileId}`);
  return response;
}

export async function deletePortfolio(portfolioId) {
  const response = await axios.post(`/DeletePortfolio?portfolioId=${portfolioId}`);
  return response;
}

export async function getTransitionStatuses() {
  const response = await axios.get('/TransitionStatuses');
  return response;
}

export async function getTransitionPageData(portfolioId) {
  const response = await axios.get(`/TransitionPageData?portfolioId=${portfolioId}`);
  return response;
}

export async function getFacilityInformationData(portfolioId, facilityId) {
  const response = await axios.get(
    `/FacilityInformationData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`
  );
  return response;
}

export async function saveFacilityInformationForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SaveFacilityInformationForm', formData);
  return response;
}

export async function getDietaryData(portfolioId, facilityId) {
  const response = await axios.get(`/DietaryData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function saveDietaryForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SaveDietaryForm', formData);
  return response;
}

export async function getOperationsData(portfolioId, facilityId) {
  const response = await axios.get(`/OperationsData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function saveOperationsForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SaveOperationsForm', formData);
  return response;
}

export async function getPharmacyData(portfolioId, facilityId) {
  const response = await axios.get(`/PharmacyData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function savePharmacyForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SavePharmacyForm', formData);
  return response;
}

export async function getBenefitsData(portfolioId, facilityId) {
  const response = await axios.get(`/BenefitsData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function saveBenefitsForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SaveBenefitsForm', formData);
  return response;
}

export async function getReportsData(portfolioId, facilityId) {
  const response = await axios.get(`/ReportsData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function saveReportsForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SaveReportsForm', formData);
  return response;
}

export async function getBusinessDevelopmentData(portfolioId, facilityId) {
  const response = await axios.get(
    `/BusinessDevelopmentData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`
  );
  return response;
}

export async function saveBusinessDevelopmentForm(data, companyId) {
  const formData = objectToFormData(data);
  formData.append('companyId', companyId);

  const response = await axios.post('/SaveBusinessDevelopmentForm', formData);
  return response;
}

export async function getVendorsData(portfolioId, facilityId) {
  const response = await axios.get(`/VendorsData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function saveVendorsForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SaveVendorsForm', formData);
  return response;
}

export async function getOutsourcedCompanyCategories() {
  const response = await axios.get('/OutsourcedCompanyCategories');
  return response;
}

export async function getTransitionVendors(companyId) {
  const response = await axios.get(`/TransitionVendors?companyId=${companyId}`);
  return response;
}

export async function getPlatformVendors() {
  const response = await axios.get(`/PlatformVendors`);
  return response;
}

export async function saveTransitionVendor(vendor, companyId) {
  const formData = objectToFormData(vendor);
  formData.append('companyId', companyId);

  const response = await axios.post('/SaveTransitionVendor', formData);
  return response;
}

export async function getPrograms(companyId) {
  const response = await axios.get(`/Programs?companyId=${companyId}`);
  return response;
}

export async function getClinicalReimbursementData(portfolioId, facilityId) {
  const response = await axios.get(
    `/ClinicalReimbursementData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`
  );
  return response;
}

export async function saveClinicalReimbursementForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SaveClinicalReimbursementForm', formData);
  return response;
}

export async function getOwnershipTypes() {
  const response = await axios.get('/OwnershipTypes');
  return response;
}

export async function getTelecommunicationsData(portfolioId, facilityId) {
  const response = await axios.get(`/TelecommunicationsData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function saveTelecommunicationsForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SaveTelecommunicationsForm', formData);
  return response;
}

export async function getPlantOperationsData(portfolioId, facilityId) {
  const response = await axios.get(`/PlantOperationsData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function savePlantOperationsForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SavePlantOperationsForm', formData);
  return response;
}

export async function getPayrollData(portfolioId, facilityId) {
  const response = await axios.get(`/PayrollData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function savePayrollForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SavePayrollForm', formData);
  return response;
}

export async function getContractedRateTypes() {
  const response = await axios.get('/ContractedRateTypes');
  return response;
}

export async function getHRData(portfolioId, facilityId) {
  const response = await axios.get(`/HRData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function saveHRForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SaveHRForm', formData);
  return response;
}

export async function fetchStaffDetails(transitionFacilityId, staffTypeId) {
  const response = await axios.get(
    `/FetchStaffDetails?transitionFacilityId=${transitionFacilityId}&staffTypeId=${staffTypeId}`
  );
  return response;
}
export async function getEnvironmentalData(portfolioId, facilityId) {
  const response = await axios.get(`/EnvironmentalData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function saveEnvironmentalForm(data) {
  const formData = objectToFormData(data);

  const response = await axios.post('/SaveEnvironmentalForm', formData);
  return response;
}

export async function getTransportationData(portfolioId, facilityId) {
  const response = await axios.get(`/TransportationData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function saveTransportationForm(data) {
  const formData = objectToFormData(data);
  const response = await axios.post('/SaveTransportationData', formData);
  return response;
}

export async function getVehicleDepartmentTypes() {
  const response = await axios.get('/VehicleDepartmentTypes');
  return response;
}

export async function getTransportationUserAccessTypes() {
  const response = await axios.get('/TransportationUserAccessTypes');
  return response;
}

export async function getClinicalData(portfolioId, facilityId) {
  const response = await axios.get(`/ClinicalData?portfolioId=${portfolioId}&sellerFacilityId=${facilityId}`);
  return response;
}

export async function saveClinicalForm(data) {
  const formData = objectToFormData(data);
  const response = await axios.post('/SaveClinicalForm', formData);
  return response;
}
